<template>
    <div class="user_core">
        <Header :title="title"></Header>
        <van-row class="info_body">
            <van-col span="24" class="info_s">
                <qrcode-vue :value="value" :size="size" level="H" />

            </van-col>
        </van-row>
        <Footer></Footer>
    </div>
</template>


<script>
    import Header from '@/components/Header.vue'
    import Footer from '@/components/Footer.vue'
    import QrcodeVue from 'qrcode.vue'

    export default {
        name: "App_down",
        data(){
            return{
                title: this.$t('app_down.pagetitle'),
                value: 'http://'+window.location.host+"/app.zip",
                size: 300,
            }
        },
        components:{
            Header,
            Footer,
            QrcodeVue
        }
    }
</script>

<style scoped lang="scss">
    .user_core{
        min-height: 650px;
        background: url("~@/assets/images/bg_header.png") no-repeat center 45px;
        background-size: 100% ;
        .info_body{
            width: 92%;
            min-height: 500px ;
            margin: 20px auto 0 auto;
            border-radius: 10px;
            background: white;
            box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
            .info_s {
                margin: 20px auto;


            }
        }
    }
</style>
